import type {PartialComponentExport} from './constants'
import type {WmlExportFormat} from '@wix/document-services-types'
import {parseXmlFile} from './structure/xmlParser'
import _ from 'lodash'
import {parseCssFile} from './style/cssParser'
import {parseJsonFile} from './other/jsonParser'
import type {DecoratedExportFormat} from '../../types'

const parseWmlFiles = ({structure, style, data, ...otherProps}: WmlExportFormat): PartialComponentExport => {
    return {
        structure: parseXmlFile(structure),
        style: parseCssFile(style),
        other: parseJsonFile(data),
        ...otherProps
    }
}

export const mergeToFullExport = (partialComponentExport: PartialComponentExport): DecoratedExportFormat => {
    const {structure, style, other, ...otherProps} = partialComponentExport

    const fullyMergedComponentExport: DecoratedExportFormat = _.merge(otherProps, other, structure, style)

    const existingComponentsIds = Object.keys(structure.components)
    fullyMergedComponentExport.components = _.pick(fullyMergedComponentExport.components, existingComponentsIds)

    return fullyMergedComponentExport
}

export const importWml = (wmlExport: WmlExportFormat): DecoratedExportFormat =>
    mergeToFullExport(parseWmlFiles(wmlExport))
